/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Gap_Frames_HelpInputs */

const en_event_gap_frames_help = /** @type {(inputs: Event_Gap_Frames_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum gap between events in frames`)
};

const fr_event_gap_frames_help = /** @type {(inputs: Event_Gap_Frames_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écart minimum entre événements en images`)
};

const de_event_gap_frames_help = /** @type {(inputs: Event_Gap_Frames_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimaler Abstand zwischen Ereignissen in Frames`)
};

const it_event_gap_frames_help = /** @type {(inputs: Event_Gap_Frames_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distanza minima tra gli eventi nei frame`)
};

const ru_event_gap_frames_help = /** @type {(inputs: Event_Gap_Frames_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минимальный промежуток между событиями в кадрах`)
};

const es_event_gap_frames_help = /** @type {(inputs: Event_Gap_Frames_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacio mínimo entre eventos en los fotogramas`)
};

const zh_cn2_event_gap_frames_help = /** @type {(inputs: Event_Gap_Frames_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帧中事件之间的最小间隔`)
};

const ja_event_gap_frames_help = /** @type {(inputs: Event_Gap_Frames_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレーム内のイベント間の最小ギャップ`)
};

const hi_event_gap_frames_help = /** @type {(inputs: Event_Gap_Frames_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़्रेमों में घटनाओं के बीच न्यूनतम अंतराल`)
};

const pt_pt2_event_gap_frames_help = /** @type {(inputs: Event_Gap_Frames_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervalo mínimo entre eventos em frames`)
};

/**
* | output |
* | --- |
* | "Minimum gap between events in frames" |
*
* @param {Event_Gap_Frames_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_gap_frames_help = /** @type {((inputs?: Event_Gap_Frames_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Gap_Frames_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_gap_frames_help(inputs)
	if (locale === "de") return de_event_gap_frames_help(inputs)
	if (locale === "it") return it_event_gap_frames_help(inputs)
	if (locale === "ru") return ru_event_gap_frames_help(inputs)
	if (locale === "es") return es_event_gap_frames_help(inputs)
	if (locale === "zh-CN") return zh_cn2_event_gap_frames_help(inputs)
	if (locale === "ja") return ja_event_gap_frames_help(inputs)
	if (locale === "hi") return hi_event_gap_frames_help(inputs)
	if (locale === "pt-PT") return pt_pt2_event_gap_frames_help(inputs)
	return en_event_gap_frames_help(inputs)
});